import { DropdownContent } from '@anm/components/Dropdown';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import Input from '@anm/components/form/Input';
import Alert from '@anm/components/notification/Alert';
import {
  OptionContainer,
  SelectOptionsContainer,
  SelectValueContainer,
  SelectWrapper
} from '@anm/components/select/Select';
import { flexColumn, flexRow, media, osScrollBar, truncate } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { InputsWrapper, Label } from '../../../StreamModalWrapper';

export const TooltipContentWrapper = styled.div`
  color: #fff;
`;

export const NewStreamInputsWrapper = styled(InputsWrapper)`
  margin: 0 0 22px 0;
`;

export const DescriptionField = styled(Input.withComponent('textarea'))`
  min-height: 86px;
  line-height: 22px;
  resize: none;
  padding: 7px 10px;
  &::placeholder {
    color: #919eaa;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 198px;
  height: 40px;
  margin-bottom: 10px;
  margin-right: 10px;
  ${DropdownContent} {
    left: 0;
    right: unset;
  }
`;

export const DateFieldWrapper = styled.div``;

export const TimeContainer = styled.div`
  max-width: 218px;
`;

const timeAndDateContainerMobile = media.phone`
  ${flexColumn};
  width: 100%;

  ${DateFieldWrapper}, ${TimeContainer}, ${DatePickerWrapper} {
    width: 100%;
    max-width: unset;
  }

  ${SelectWrapper} {
    width: calc(100% / 3);
    ${SelectValueContainer} {
      width: calc(100% - 10px);
    }
    &:last-child ${SelectValueContainer} {
      width: 100%;
    }
  }
`;

export const TimeAndDateContainer = styled.div`
  ${flexRow};
  margin-right: auto;
  ${Label} {
    margin-bottom: 8px;
    ${truncate('100%')}
  }
  ${timeAndDateContainerMobile};
`;

export const TimeRow = styled.div`
  display: flex;
  ${SelectValueContainer} {
    width: 64px;
    height: 40px;
    margin-right: 10px;
    padding-left: 10px;
    &:after {
      right: 12px;
      position: absolute;
    }
  }
  ${SelectWrapper}:last-child ${SelectValueContainer} {
    margin: 0;
    &:after {
      right: 2px;
    }
  }
  ${SelectOptionsContainer} {
    width: 66px;
    overflow: auto;
    max-height: 190px;
    ${OptionContainer} {
      padding: 0 15px;
    }
    ${osScrollBar};
  }
`;

export const commonMessageStyles = css`
  display: block;
  padding: 15px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 10px;
  color: var(---gray_900);
  max-width: fit-content;
`;

export const WarnMessage = styled(Alert)`
  && {
    margin-top: 5px;
    margin-bottom: 18px;
    ${commonMessageStyles};
  }

  a {
    text-decoration: underline;
  }
`;

export const SwitchContainer = styled.label`
  ${flexRow};
  cursor: pointer;
  margin-top: -6px;
  margin-bottom: 16px;
  span {
    margin-left: 10px;
    line-height: 22px;
  }
`;

const buttonsContainerMobile = media.phone`
  margin: 0;
`;

export const ButtonsContainer = styled.div`
  ${flexRow};
  gap: 10px;
  margin-top: 24px;
  justify-content: center;
  button {
    max-width: 200px;
  }

  ${buttonsContainerMobile};
`;

export const SaveButton = styled(ButtonLoader)`
  min-width: 100px;
  font-size: 16px;
`;

export const ScheduleSection = styled.div``;

const mobileHint = media.phone`
  margin: 0;
`;

export const Hint = styled.div`
  font-size: 16px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 13px;
  align-items: center;
  color: var(--gray_900);
  p {
    margin: 0;
  }
  span {
    font-size: 12px;
  }

  ${mobileHint};
`;

export const NewStreamConfigsWrapper = styled.div`
  ${flexColumn};
  padding-bottom: 10px;
  ${Hint} {
    margin-top: 0;
  }
`;

export const UploadContainer = styled.div`
  display: flex;
  margin-top: 15px;
  margin-bottom: 16px;
  justify-content: space-between;
`;
